











































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import axios from "axios";

axios.defaults.baseURL = process.env.BASE_URL;

@Component
export default class CreditsViewer extends Vue {
  @Prop({ default: false })
  displayHelp!: boolean;

  @Prop()
  private userId: string | undefined;

  private q_description: any = {
    P2T: "DeSI-Talents",
    P2T_FREE: "DeSI-P2T Gestion des Talents (gratuit)",
    P2T_OPT1: "DeSI-P2T Gestion des Talents (Option 1)",
    P2T_OPT2: "DeSI-P2T Gestion des Talents (Option 2)",
    P2T_OPT3: "DeSI-P2T Gestion des Talents (Option 3)",
    P2R: "DeSI-P2R Recrutement",
    P7: "DeSI-P7 Coaching",
    "P7+8": "DeSI-P7+8 Orientation",
    S2: "DeSI-S2",
    S7: "DeSI-S7 Coaching",
    "S7+8": "DeSI-S7+8 Orientation",
    "DeSI-ACTIV": "Desi-Métiers",
    "Evaluation Neuroscience": "Evaluation Neuroscience",
  };

  private credits: Array<any> = [];
  private normatifTests: Array<any> = [];

  fetchData() {
    console.log("fetch data");
    axios
      .get("/api/balance", { params: { userId: this.userId } })
      .then(ans => {
        this.credits = ans.data;
        this.loadNormatifTests();
      })
      .catch(console.log);
  }

  async loadNormatifTests() {
    try {
      const response = await axios.get("/api/tests");
      this.normatifTests = response.data;
      this.updateNormatifDescriptions();
    } catch (error) {
      console.error("Erreur lors du chargement des tests normatifs:", error);
    }
  }

  updateNormatifDescriptions() {
    this.normatifTests.forEach(test => {
      const key = `NORMATIF_TEST_${test.id}`;

      if (this.credits[key] && test.name) {
        this.q_description[key] = test.name;
      }
    });
  }
get filteredCredits() {
  const out: any = {};

  Object.entries(this.credits).forEach(([key, value]) => {
    if (key.startsWith("NORMATIF_TEST_")) {
      const id = key.replace("NORMATIF_TEST_", "");
      const test = this.normatifTests.find(t => String(t.id) === id);

      if (test && test.name) {
        out[key] = value;
      }
    } else {
      out[key] = value;
    }
  });

  return out;
}

  getCreditDescription(creditName: string): string | null {
    if (creditName.startsWith("NORMATIF_TEST_")) {
      const id = creditName.replace("NORMATIF_TEST_", "");
      const test = this.normatifTests.find(t => String(t.id) === id);

      return test?.name || null;
    }

    return this.q_description[creditName] || creditName;
  }

  shouldDisplay(cName: string): boolean {
    if (cName.startsWith("NORMATIF_TEST_")) {
      const id = cName.replace("NORMATIF_TEST_", "");
      const test = this.normatifTests.find(t => String(t.id) === id);

      return !!(test && test.name); 
    }

    return true;
  }

  @Watch("userId")
  userIdChanged(v) {
    if (v) {
      this.fetchData();
    }
  }

  mounted() {
    if (this.userId) {
      this.fetchData();
    }
  }
}
